<template>
    <v-form @submit.prevent="sendOrder" ref="refOrder" lazy-validation>
        <v-card tile elevation="0">
            <v-card-title>
                Editar preventa
            </v-card-title>

            <!-- contenido -->
            <v-card-text class="pa-0" v-if="!loading">
                <v-card-title class="py-3 blue-grey lighten-5">
                    Datos del cliente
                </v-card-title>
                <div class="pa-3">
                    <!-- <v-btn
                        color="primary"
                        @click="dialogClient=true"
                    >Buscar cliente</v-btn> -->
                    <v-row class="mt-5">
                        <v-col cols="6" class="py-0">
                            <v-text-field
                                label="Nombre(s) *"
                                color="primary"
                                outlined
                                dense
                                v-model="client.name"
                                :rules="[rules.required]"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="py-0">
                            <v-text-field
                                label="Apellido(s) *"
                                color="primary"
                                outlined
                                dense
                                v-model="client.lastname"
                                :rules="[rules.required]"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="py-0">
                            <vue-tel-input-vuetify
                                label="Celular (opcional)"
                                color="primary"
                                outlined
                                dense
                                :defaultCountry="iso2"
                                :onlyCountries="[iso2]"
                                :value="tmpPhone"
                                @input="onInput"
                            ></vue-tel-input-vuetify>
                        </v-col>
                    </v-row>
                </div>

                <v-card-title class="py-3 blue-grey lighten-5">
                    Dirección de entrega
                </v-card-title>
                <google-map
                    :center="{lat: centerLat, lng: centerLng}"
                    :zoom="13"
                    btn-color="primary"
                    @result-click="resultClickMap"
                    v-if="showMap"
                ></google-map>
                <div class="pa-3">
                    <v-text-field
                        label="Dirección de entrega *"
                        color="primary"
                        outlined
                        dense
                        v-model="deliveryAddress"
                        :rules="[rules.required]"
                    ></v-text-field>
                    <v-textarea
                        label="Aclaración de dirección"
                        placeholder="Ejm. Casa rojo con puerta de metal"
                        outlined
                        color="primary"
                        rows="3"
                        v-model="addressClarification"
                    ></v-textarea>
                </div>

                <v-card-title class="py-3 blue-grey lighten-5">
                    Método de pago
                </v-card-title>
                <div class="pa-3">
                    <v-radio-group
                        v-model="paymentMethod"
                        row
                        :rules="[rules.required]"
                    >
                        <v-radio
                            v-if="enableUponDelivery"
                            label="Pago Contraentrega"
                            value="cash_payment"
                            color="primary"
                        ></v-radio>
                        <v-radio
                            v-if="enablePaymentMethod"
                            label="Pago Qr/Transferencia Bancaria"
                            value="bank_payment"
                            color="primary"
                        ></v-radio>
                        <v-radio
                            v-if="enablePaymentCard"
                            label="Pago tarjeta de débito/crédito"
                            value="card_payment"
                            color="primary"
                        ></v-radio>
                        <v-radio
                            v-if="enableVeMethod && iso2=='VE'"
                            label="Pago por PagomóvilBDV"
                            value="bank_ven"
                            color="primary"
                        ></v-radio>
                    </v-radio-group>
                    <div v-if="paymentMethod == 'bank_payment'" class="text-center">
                        <v-img
                            :src="codePaymentMethod"
                            max-width="300px"
                            class="mx-auto mb-2"
                        ></v-img>
                        <v-btn
                            :href="codePaymentMethod"
                            download
                            color="primary"
                            dark
                            small
                            class="mb-2"
                        >
                            Descargar QR
                        </v-btn>
                        <p class="mb-0">Banco: {{ payment.bank }}</p>
                        <p class="mb-0">Cuenta: {{ payment.account }}</p>
                        <p class="mb-0">Nombre: {{ payment.name }}</p>
                        <p class="mb-10">NIT: {{ payment.nit }}</p>
                    </div>
                    <div v-if="paymentMethod == 'bank_ven'" class="text-center">
                        <v-img
                            :src="venPaymentMethod"
                            max-width="300px"
                            class="mx-auto mb-2"
                        ></v-img>
                        <p class="mb-0">Banco: {{ payment2.bank }}</p>
                        <p class="mb-0">Documento: {{ payment2.document }}</p>
                        <p class="mb-0">Nombre: {{ payment2.name }}</p>
                        <p class="mb-10">Tel: {{ payment2.tel }}</p>
                    </div>
                </div>

                <v-card-title class="py-3 blue-grey lighten-5">
                    Resumen de orden
                </v-card-title>
                <div class="pa-3">
                    <v-simple-table dense class="mb-5">
                        <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left grey--text text--lighten-1">
                                    Cantidad
                                </th>
                                <th class="text-left grey--text text--lighten-1">
                                    Producto
                                </th>
                                <th class="text-right grey--text text--lighten-1">
                                    Precio
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in cart" :key="i">
                                <td class="text-left">{{ item.quantity }}x</td>
                                <td class="text-left">{{ item.name }}</td>
                                <td class="text-right">{{ money }} {{ item.price }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>
                                    <strong class="text-h6">Subtotal</strong>
                                </td>
                                <td colspan="2" class="text-right">
                                    <strong class="text-h6">{{ money }} {{ total }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong class="text-h5">Total</strong>
                                </td>
                                <td colspan="2" class="text-right">
                                    <strong class="text-h5">{{ money }} {{ (total>0)?total:0 }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong class="text-h6">Pagado a cuenta</strong>
                                </td>
                                <td colspan="2" class="text-right">
                                    <v-text-field
                                        placeholder="Pagado a cuenta"
                                        dense
                                        outlined
                                        hide-details
                                        style="width:120px"
                                        class="ml-auto in-right"
                                        type="number"
                                        :rules="[rules.required]"
                                        v-model="balance"
                                    ></v-text-field>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong class="text-h6">Saldo</strong>
                                </td>
                                <td colspan="2" class="text-right">
                                    <strong class="text-h5">{{ money }} {{ (total>0)?(total-balance):0 }}</strong>
                                </td>
                            </tr>
                        </tfoot>
                        </template>
                    </v-simple-table>
                    <v-checkbox
                        v-model="dataPrch.remarkOrder"
                        color="primary"
                        label="Incluir un comentario para la orden"
                        hide-details
                    ></v-checkbox>
                    <v-textarea
                        placeholder="Ejm. Si es posible un poco de sal extra por favor."
                        outlined
                        color="primary"
                        rows="3"
                        v-model="dataPrch.commentOrder"
                        v-if="dataPrch.remarkOrder"
                        :rules="[rules.required]"
                    ></v-textarea>
                </div>

                <v-card-title class="py-3 blue-grey lighten-5">
                    Datos de facturación
                </v-card-title>
                <div class="pa-3">
                    <v-text-field
                        label="Razón social"
                        color="primary"
                        outlined
                        dense
                        v-model="businessName"
                    ></v-text-field>
                    <v-text-field
                        label="NIT / CI"
                        color="primary"
                        outlined
                        dense
                        v-model="document"
                    ></v-text-field>
                </div>
            </v-card-text>
            <!-- END contenido -->

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    text
                    @click="$emit('close-dialog')"
                >Cancelar</v-btn>
                <v-btn
                    color="primary"
                    type="submit"
                >Actualizar</v-btn>
            </v-card-actions>
            <!-- overlay -->
            <v-overlay :value="loading" absolute opacity=".9" z-index="10">
                <v-progress-circular
                    indeterminate
                    size="64"
                    color="primary"
                ></v-progress-circular>
            </v-overlay>
            <!-- end overlay -->
        </v-card>
    </v-form>
</template>
<script>
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue';
export default {
    components: {
        VueTelInputVuetify,
    },
    data() {
        return {
            // client
            client: {
                id: 'none',
                name: '',
                lastname: '',
                phone: ''
            },
            // location
            centerLat: -17.3751345,
            centerLng: -66.1844502,
            showMap: true,
            lat: null,
            lng: null,
            address: '',
            deliveryAddress: '',
            addressClarification: '',
            // loading
            loading: false,
            // pago
            paymentMethod: '',
            enableUponDelivery: false,
            enablePaymentMethod: false,
            enablePaymentCard: false,
            codePaymentMethod: '',
            payment: {
                bank: '',
                account: '',
                name: '',
                nit: ''
            },
            enableVeMethod: false,
            venPaymentMethod: '',
            payment2: {
                bank: '',
                document: '',
                name: '',
                tel: ''
            },
            // facturas
            businessName: '',
            document: '',
            // cart
            cart: [],
            dataPrch: {
                remarkOrder: false,
                commentOrder: ''
            },
            total: 0,
            // balance
            balance: 0,
            // phone
            tmpPhone: '',
            phoneCode: '',
            phoneValid: false,
            phoneNumber: '',
            iso2: '',
            // rules
            rules: {
                required: v => !!v || 'El campo es requerido',
                requiredDates: v => v.length>0 || 'El campo es requerido',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                phone: v => (v.length >= 8 && v.length <= 8) || 'Debe contener 8 dígitos',
                email: v => /.+@.+\..+/.test(v) || 'Correo electrónico inválido'
            },
        }
    },
    props: ['presaleId', 'slug', 'money'],
    mounted() {
        this.getMainData()
        // console.log('Component mounted.')
        this.getPresaleData()
    },
    methods: {
        // map
        resultClickMap(resp) {
            this.lat = resp.lat
            this.lng = resp.lng
            this.address = resp.address
        },
        // phone
        onInput(formattedNumber, { number, valid, country }) {
            this.phoneCode = '+'+country.dialCode
            this.phoneNumber = number.significant
            this.tmpPhone = number.international
            this.phoneValid = valid
        },
        async getMainData() {
            await axios.get(`/data-order/${this.slug}`)
            .then((response) => {
                // console.log(response)
                if (response.data[0]) {
                    const contentPayment = JSON.parse(response.data[0].content)
                    this.enablePaymentMethod = (contentPayment.enable)?true:false
                    this.codePaymentMethod = contentPayment.codeQr
                    this.payment.bank = contentPayment.bank
                    this.payment.account = contentPayment.account
                    this.payment.name = contentPayment.name
                    this.payment.nit = contentPayment.nit
                }
                if (response.data[1]) {
                    const contentAddress = JSON.parse(response.data[1].content)
                    if (contentAddress.length > 0) {
                        this.addressOfPickUp = contentAddress[0]
                        this.listAddressOfPickUp = contentAddress
                    }
                }
                if (response.data[2]) {
                    const contentCard = JSON.parse(response.data[2].content)
                    this.enablePaymentCard = (contentCard.enable)?true:false
                }
                if (response.data[5]) {
                    const contentUponDelivery = JSON.parse(response.data[5].content)
                    this.enableUponDelivery = (contentUponDelivery.enable)?true:false
                }
                if (response.data[6]) {
                    const contentInvoice = JSON.parse(response.data[6].content)
                    this.enableInvoice = (contentInvoice.enable)?true:false
                }
                if (response.data[7]) {
                    const contentTable = JSON.parse(response.data[7].content)
                    this.enableTable = (contentTable.enable)?true:false
                }
                if (response.data[14]) {
                    const contentPayment = JSON.parse(response.data[14].content)
                    this.enableVeMethod = (contentPayment.enable)?true:false
                    this.venPaymentMethod = contentPayment.imgBank
                    this.payment2.bank = contentPayment.bank
                    this.payment2.document = contentPayment.document
                    this.payment2.name = contentPayment.name
                    this.payment2.tel = contentPayment.tel
                }
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        /**
         * data
         */
        async getPresaleData() {
            this.loading = true
            await axios.get('/admin/presale-show/' + this.presaleId)
                .then(response => {
                    // console.log(response.data)
                    this.client.id = response.data.client.id
                    this.client.name = response.data.client.name
                    this.client.lastname = response.data.client.lastname
                    this.client.phone = response.data.client.phone
                    this.iso2 = response.data.client.iso2
                    this.tmpPhone = response.data.client.phone

                    this.centerLat = +response.data.lat_map
                    this.centerLng = +response.data.lng_map
                    this.deliveryAddress = response.data.delivery_address
                    this.addressClarification = response.data.address_clarification
                    this.lat = response.data.lat_map
                    this.lng = response.data.lng_map
                    this.address = response.data.address_map
                    setTimeout(() => {
                        this.showMap = true
                    }, 500);

                    this.paymentMethod = response.data.payment_method

                    this.businessName = response.data.business_name
                    this.document = response.data.document

                    this.cart = response.data.products
                    this.dataPrch.remarkOrder = response.data.remark_order?true:false
                    this.dataPrch.commentOrder = response.data.comment_order
                    this.total = response.data.total
                    this.balance = response.data.balance

                    this.loading = false
                })
                .catch(error => {
                    // console.log(error)
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                    this.loading = false
                })
        },

        /**
         *
         * ---------------- order -----------
         *
         */
        async sendOrder() {
            if (this.tmpPhone) {
                if (!this.phoneValid) {
                    this.$alert('Número de celular inválido.')
                    return
                }
            }
            if (this.$refs.refOrder.validate()) {
                this.loading = true
                // send data
                const dataForm = new FormData()
                dataForm.append('store', this.slug)
                dataForm.append('payment_method', this.paymentMethod)
                // datos personales
                dataForm.append('id_client', this.client.id)
                dataForm.append('name', this.client.name)
                dataForm.append('lastname', this.client.lastname)
                dataForm.append('phone_number', this.phoneNumber??'')
                dataForm.append('code', this.phoneCode??'')
                dataForm.append('iso2', this.iso2??'')
                // resumen de orden
                dataForm.append('remark_order', (this.dataPrch.remarkOrder)?1:0)
                dataForm.append('comment_order', this.dataPrch.commentOrder)
                // facturas
                dataForm.append('business_name', this.businessName)
                dataForm.append('document', this.document)
                // carrito
                // dataForm.append('cart', JSON.stringify(this.cart))
                dataForm.append('total', this.total)
                // location
                dataForm.append('lat', this.lat)
                dataForm.append('lng', this.lng)
                dataForm.append('address', this.address)
                dataForm.append('delivery_address', this.deliveryAddress)
                dataForm.append('address_clarification', this.addressClarification)
                dataForm.append('balance', this.balance)

                dataForm.append('_method', 'PUT')

                await axios.post(`/preventist/send-order/${this.presaleId}`, dataForm)
                .then((response) => {
                    // console.log(response)
                    if (response.data === 'ok') {
                        this.$fire({
                            title: 'Pedido realizado con éxito.',
                            text: 'Su pedido fue realizado con éxito.',
                            type: 'success',
                            confirmButtonText: 'Continuar',
                            reverseButtons: true,
                            showCancelButton: false,
                        }).then(resp => {
                            if (resp.value) {
                                this.$emit('close-dialog')
                            }
                        })
                    }
                    this.$emit('close-dialog')
                    this.loading = false
                })
                .catch((error) => {
                    // console.log(error)
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                    this.loading = false
                })
                // send data END
            } else {
                this.$notify.error('Campos requeridos vacios')
            }
        },
    }
}
</script>
